import { render, staticRenderFns } from "./scoreInput.vue?vue&type=template&id=222ad23c&scoped=true"
import script from "./scoreInput.vue?vue&type=script&lang=js"
export * from "./scoreInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "222ad23c",
  null
  
)

export default component.exports